/* Core & libraries */
import React from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
/* Components */
import { ReactComponent as LoyaltySvg } from '../../resources/images/loyalty.svg';
import { ReactComponent as Close } from "../../resources/images/icon-notification-close.svg";

/* Styles */
import styles from "./styles.js"

const LoyaltyBanner = (props) => {
  const { title, message, setShowLoyaltyBanner } = props;
  const theme = useTheme();
  const classes = styles({ theme });
  
  return (
    <div className={classes.banner}>
      <div className={classes.bannerContent}>
        <div className={classes.icon}>
          <LoyaltySvg/>
        </div>
        <div className={classes.bannerTextContainer}>
          <div className={classes.bannerTitle}>{title}</div>
          <div className={classes.message}>{message}</div>
        </div>
      </div>
      <Close className={classes.closeIcon} onClick={() => setShowLoyaltyBanner(false)}/>
    </div>
  )
}

export default LoyaltyBanner;